import MgpFormRadio from '../../../elements/MgpFormRadio/MgpFormRadio';
import { UseFormClearErrors, UseFormGetValues, UseFormRegister, UseFormSetValue, UseFormWatch } from 'react-hook-form';
import { accessJsonAttr } from '../../../utils/utils';
import MgpFormInput from '../../../elements/MgpFormInput/MgpFormInput';
import {  useEffect, useState } from 'react';
import { IChildDetail, IPartnerDetail } from '../../../context/model';
import MgpFormCheckbox from '../../../elements/MgpFormCheckbox/MgpFormCheckbox';
import MgpTooltip from '../../../elements/MgpTooltip/MgpTooltip';
import { ERROR_MESSAGES } from '../../../const/AppConst';
import ImageModal from '../../../modals/common/ImageModal';

type SituationBeneficiaryFormComponentProps = {
    register: UseFormRegister<any>;
    errors: any;
    getValues: UseFormGetValues<any>;
    watch: UseFormWatch<any>;
    setValue: UseFormSetValue<any>;
    childrenList: IChildDetail[];
    partnerInfo: IPartnerDetail;
    clearErrors: UseFormClearErrors<any>
}

export default function SituationBeneficiaryFormComponent({
    register, 
    errors, 
    getValues, 
    watch, 
    setValue, 
    childrenList, 
    partnerInfo,
    clearErrors} : Readonly<SituationBeneficiaryFormComponentProps>) {
    const list = watch('childrenList');
    const partner = watch('partnerInfo');

    const [numberOfChildren, setNumberOfChildren] = useState<number>(list.length ?? 1);
    const [imageUrl, setImageUrl] = useState<string>('');

    useEffect(()=>{
        const getList = () => {
            const newNames = [...childrenList];
            while (newNames.length < numberOfChildren) newNames.push({
                birthDate: '',
                hasAlsaceMoselle: false,
                hasHandicap: false
            } as IChildDetail);
            return newNames.slice(0, numberOfChildren);
          }
     
        setValue('childrenList', getList());
    }, [numberOfChildren])

    const handleNumberChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = parseInt(e.target.value, 10) || 0;
        if(value<1) {
            setNumberOfChildren(1)
        } else if(value>5) {
            setNumberOfChildren(5)
        } else {
            setNumberOfChildren(value);
        }      
    };

    const handleNameChange = (e: React.ChangeEvent<HTMLInputElement>, index: number, key: string) => {
        const newList = [...list];
        newList[index][key] = e.target.value;
        setValue('childrenList', newList);
    };

    const handleChangeCheckbox = (e: React.ChangeEvent<HTMLInputElement>, index: number, key: string) => {
        const newList = [...list];
        newList[index][key] = e.target.checked;
        setValue('childrenList', newList);
    };
  

    const onHasChildHandler = ()=> {
        if(getValues('hasChild').toString() === 'true' ){
            const newList = [{
                birthDate: '',
                hasAlsaceMoselle: false,
                hasHandicap: false
            }]
            setValue('childrenList', newList);
            setNumberOfChildren(1)
        }
        if(getValues('hasChild').toString() === 'false'){
            setValue('childrenList', []);
            setNumberOfChildren(0);
            clearErrors('childrenList')
        }   
    }

    const onHasPartnerHandler = ()=> {
        if(getValues('hasPartner').toString() === 'true' ){
            setValue('partnerInfo', {
                birthDate: '',
                hasAlsaceMoselle: false
            });
        }
        if(getValues('hasPartner').toString() === 'false'){
            setValue('partnerInfo', {});
            clearErrors('partnerInfo')
        }
    }

    const handleOpenInfoModal = () => {
      setImageUrl('AD-bull.png');
    }

    const handleCloseInfoModal = () => {
      setImageUrl('');
    }

 
    const partnerInfoErr = accessJsonAttr(errors, 'partnerInfo');
    const childrenErr = accessJsonAttr(errors, 'childrenList');
    
    const requiredMsgErr = errors 
    && partnerInfoErr?.birthDate?.message===ERROR_MESSAGES.requiredMsg 
    || (childrenErr?.length ===1
        && childrenErr?.[0]?.birthDate?.message===ERROR_MESSAGES.requiredMsg) 
    || ((childrenErr?.length > 1 &&
        childrenErr?.findIndex((child: any) => 
            child?.birthDate?.message=== ERROR_MESSAGES.requiredMsg) !==-1));

    const invalidMsgErr = errors 
    && (partnerInfoErr?.birthDate?.message===ERROR_MESSAGES.invalidMsg 
    || (childrenErr?.length ===1 
        && childrenErr?.[0]?.birthDate?.message=== ERROR_MESSAGES.invalidMsg)
    || ((childrenErr?.length >1 
        && childrenErr?.findIndex((child: any) => 
            child?.birthDate?.message=== ERROR_MESSAGES.invalidMsg) !==-1)))

    const invalidAge = errors
    && ((childrenErr?.length >0
    && childrenErr?.findIndex((child: any) => 
        child?.birthDate?.message=== ERROR_MESSAGES.invalidAge) !==-1))

    return (             
        <>
            <h2 className='card-title bleu'>          
                Souhaitez vous ajouter des ayants droit ? <span className='fushia'> (*)</span>
                <button 
                    type='button' 
                    onClick={handleOpenInfoModal} 
                    className="info-badge info-button" 
                    title="Cliquer pour voir les instructions.">
                        <span className=''>
                            i
                        </span>
                </button> 
            </h2>
            

            <div className='form-row mt-md mw-100 va-center'>
                <h2 className='form-group mw-35 bleu fz-x-normal fw-medium'>
                    Votre conjoint 
                </h2>
                <div className='' >
                    <div className='flex va-center jc-start' onChange={()=>onHasPartnerHandler()}>
                        <MgpFormRadio 
                            id="hasPartner" 
                            value='true' 
                            label='Oui' 
                            register={register} 
                            errors={errors}
                        />
                        <MgpFormRadio 
                            id="hasPartner" 
                            value='false' 
                            label='Non' 
                            register={register} 
                            errors={errors}
                        />
                    </div>
                </div>
            </div>
            {errors 
            && accessJsonAttr(errors, 'hasPartner') 
            && <p className="error fushia m-y-xs">
                Veuillez choisir au moins une case
            </p>}
            
            <div className='pb-lg'>
                <div className='form-row mw-100 va-center'>
                    <h2 className='form-group mw-35 bleu fz-x-normal fw-medium'>Vos enfants</h2>
                    <div className='' >
                        <div 
                            className='flex va-center jc-start' onChange={()=>onHasChildHandler()}  >
                                <MgpFormRadio 
                                        id="hasChild" 
                                        value='true' 
                                        label='Oui' 
                                        register={register} 
                                        errors={errors} 
                                        // onChange={()=>onHasChildHandler()} 
                                        />
                                <MgpFormRadio 
                                        id="hasChild" 
                                        value='false' 
                                        label='Non' 
                                        register={register} 
                                        errors={errors} 
                                        // onChange={()=>onHasChildHandler()}
                                         />
                        </div>
                    </div> 
                </div> 
                <div className='form-row'>
                    {errors 
                    && accessJsonAttr(errors, 'hasChild') 
                    && <p className="error fushia m-y-xs">
                        Veuillez choisir au moins une case
                    </p>} 
                </div>
            </div>
            {
                watch('hasChild') === 'true' 
                && (     
                <div className='form-row mw-100 va-center'>
                    <h2 className='form-group mw-55 bleu fz-x-normal fw-medium'>
                        Nombre d’enfants ou petits enfants à charge
                    </h2>
                    <div className='form-group mw-25' >
                        <div className='flex va-center jc-start'>
                            <MgpFormInput id='numberOfChild' 
                                type='number' 
                                value={numberOfChildren} 
                                min={1} max={5} 
                                onChange={(e) => handleNumberChange(e)}
                            />
                        </div>
                    </div>
                </div>     
                )
            }
            {
                (watch('hasChild') === 'true' || watch('hasPartner') === 'true') && (
                    <table className="simple-table no-border ta-center" width="100%">
                        <thead>
                        <tr>
                            <th style={{width: "20%"}}></th>
                            <th style={{width: "30%"}}>Date de naissance</th>
                            <th style={{width: "25%"}}>Régime Alsace-Moselle</th>
                            <th style={{width: "25%"}}>En situation de handicap    
                                <MgpTooltip 
                                    maxWidth='350px'
                                    text="Les ayants droit enfants,  en situation de handicap, peuvent continuer à bénéficier de l’adhésion sans limitation d’âge sous réserve d’une justification attestant de la reconnaissance de l’handicap">
                                    <p className='info-badge info-icon' style={{marginTop: '-14px'}}>i</p></MgpTooltip>
                        </th>
                        </tr>
                        </thead>
                        <tbody>
                            {
                                watch('hasPartner') === 'true' && 
                                <tr >
                                <td>Votre conjoint</td>
                                    <td>
                                        <MgpFormInput
                                            label=""
                                            id={`partnerInfo.birthDate`}
                                            labelFontWeight='medium'
                                            errors={{errors}}
                                            type='date'
                                            onChange={(e) => setValue(
                                                'partnerInfo', 
                                                {...partner,
                                                 birthDate: e.target.value})}
                                            value={partner.birthDate}
                                        /> 
                                    </td>
                                    <td>
                                        <MgpFormCheckbox 
                                            id={`partnerInfo.hasAlsaceMoselle`}
                                            label=""
                                            register={register} 
                                            onChange={(e) => setValue(
                                                'partnerInfo', 
                                                {...partner, 
                                                hasAlsaceMoselle: e.target.checked})}
                                            className='rounded-checkbox '
                                            checked={partner.hasAlsaceMoselle}
                                        /> 
                                    </td>
                                    <td>
                                         
                                    </td>
                                </tr>
                            }
                            {
                                watch('hasChild') === 'true' &&
                                list.map((child: IChildDetail,i: number) => <tr key={i+1}>
                                    <td>
                                        <p className={`${!requiredMsgErr && !invalidMsgErr && childrenErr?.[i]?.birthDate?.message === ERROR_MESSAGES.invalidAge && 'error fushia' }`}>Enfant&nbsp;{i+1}</p>
                                    </td>
                                    <td>
                                        <MgpFormInput
                                            label=""
                                            id={`children.${[i]}.birthDate`}
                                            labelFontWeight='medium'
                                            type='date'
                                            errors={errors}
                                            onChange={(e) => handleNameChange(e,i,"birthDate")}
                                            value={child.birthDate}
                                        /> 
                                    </td>
                                    <td>
                                        <MgpFormCheckbox 
                                            id={`children.${[i]}.hasAlsaceMoselle`}
                                            label=""
                                            register={register} 
                                            onChange={(e) => handleChangeCheckbox(e, i,"hasAlsaceMoselle")}
                                            className='rounded-checkbox'
                                            checked={child.hasAlsaceMoselle}
                                        /> 
                                    </td>
                                    <td>
                                        <MgpFormCheckbox 
                                            id={`children.${[i]}.hasHandicap`}
                                            label=""
                                            register={register} 
                                            onChange={(e) => handleChangeCheckbox(e, i,"hasHandicap")}
                                            className='rounded-checkbox'
                                            checked={child.hasHandicap}
                                        /> 
                                    </td>
                                    <p></p>
                                </tr>)
                            }
                        
                        </tbody>
                    </table>
                )               
            } 

            {imageUrl && <ImageModal isOpen={true} name={imageUrl} onCloseModal={handleCloseInfoModal}/>}
            
     
            {requiredMsgErr  
            && (<p className="error fushia m-y-xs">
             Veuillez compléter les informations de votre ayant droit.
            </p>) }

            {!requiredMsgErr && 
            invalidMsgErr 
            && (<p className="error fushia m-y-xs">
               L'information renseignée semble incorrecte
            </p>) 
            } 

            {!requiredMsgErr && 
            !invalidMsgErr &&
            invalidAge &&
             (<p className="error fushia m-y-xs">
              {ERROR_MESSAGES.invalidAge}
            </p>) 
            }  
        </>         
  )
}
